import React from 'react';
import { Button, Modal, Typography } from '@attentive-platform/stem-ui';

import { ReopenModalStyles as S } from './styles';

const AdoptModal = ({ open, onClose, onConfirm, submitting, companyName }) => (
  <Modal
    show={open}
    onClose={onClose}
    heading={<span className='pl-4'>Adopt as scope of record</span>}
    content={
      <S.ContentWrap>
        <S.Heading>Adopt this version?</S.Heading>
        <Typography variant='body3' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
          Adopt this submitted version as
          {companyName ? ` ${companyName}'s` : ' the company’s'} scope of record. Outcome becomes Live, and this
          version is used as the company’s current scope.
        </Typography>

        <S.Actions>
          <Button variant='outlined' color='primary' size='medium' onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='medium'
            loading={submitting}
            disabled={submitting}
            onClick={onConfirm}>
            Adopt
          </Button>
        </S.Actions>
      </S.ContentWrap>
    }
  />
);

export default AdoptModal;
